export const manageWorkersMatomo = 'manage_workers_form_navigation';
export const reportSalaryMatomo = 'report_salary_form_navigation';
export const fileReportMatomo = 'file_upload_form_navigation';
export const fileUploadMatomo = 'file_upload_complete';

export const matomoTracking = (eventText: string, stepText?: string, fileFormat?: string) => {
  (window as any)._mtm = (window as any)._mtm || [];

  const mtmObject: { event: string; step_text?: string; file_format?: string } = { event: eventText };

  if (stepText) {
    mtmObject.step_text = stepText;
  }

  if (fileFormat) {
    mtmObject.file_format = fileFormat;
  }

  (window as any)._mtm.push(mtmObject);
};
